import {Styles} from 'config';
import React from 'react';

interface IModalDescriptionProps {
  text: string;
}

const ModalDescription: React.FC<IModalDescriptionProps> = ({text}) => {
  return (
    <div className="text-md md:text-lg text-center mb-6" style={{color: Styles.colors.gray.strong}}>
      {text}
    </div>
  );
};

export default ModalDescription;
